// DS: CR17, CMPST05
import React from 'react';
import FolderContent from './_partials/FolderContent';
import FolderPanel from './_partials/FolderPanel';
import ErrorBoundary from '../../../ErrorBoundary';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import s from './ShopFolderThumb.scss';
export const PANEL_HEIGHT = 82;
export const DEFAULT_THUMB_HEIGHT = 337;
const ShopThumb = ({ folder, width, height = DEFAULT_THUMB_HEIGHT + PANEL_HEIGHT })=>{
    const { pointPrice, formattedDollarPrice } = normalizePremiumFolderData(folder.premiumFolderData);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "ShopFolderThumb"
    }, /*#__PURE__*/ React.createElement(FolderContent, {
        folder: folder,
        width: width,
        height: height - PANEL_HEIGHT
    }), /*#__PURE__*/ React.createElement(FolderPanel, {
        folder: folder,
        price: pointPrice,
        dollarsCost: formattedDollarPrice
    })));
};
ShopThumb.displayName = 'ShopThumbFolder';
export default ShopThumb;
